import AudiencePage from "@/components/AudiencePage";

export default function Councils() {
  return (
    <AudiencePage
      testId="councils-page"
      accentDark
      overline="For Councils · Review & Validate"
      title="Accept only ADAC data you can trust."
      subtitle="Validate incoming submissions against one consistent standard, spot non-compliance instantly, and keep a clear, audit-ready trail for every handover."
      image="https://images.unsplash.com/photo-1581092570490-cc40829efaae?auto=format&fit=crop&w=1000&q=70"
      extraCta={{ label: "Capability statement", href: "/councils-brief" }}
      pains={[
        "Submissions that fail late — after time has already been spent reviewing them.",
        "Inconsistent acceptance standards between reviewers and projects.",
        "No fast way to compare a resubmission against the original.",
        "Manual checks that are slow, error-prone, and hard to defend.",
      ]}
      gains={[
        "Validate submissions in minutes against your acceptance profile.",
        "Apply one consistent standard across every reviewer and project.",
        "Instantly compare resubmissions to the original file.",
        "Export audit-ready reports for a clean, defensible paper trail.",
        "Give Consultants the exact standard you validate against.",
      ]}
    />
  );
}
